import React, { useEffect, useRef, useState } from 'react';
import { ReactFlowProvider } from 'reactflow';
import CareerMap from './CareerMap';
import useIsMobile from '../hooks/useIsMobile';
import '../styles/mobile-immersive.css';
import MapFabMobile from './MapFabMobile.jsx';

const CareerMapWrapper = (props) => {
  const isMobile = useIsMobile(768);
  const [immersive, setImmersive] = useState(() => {
    try { return JSON.parse(localStorage.getItem('ui@mobileImmersive') || 'false'); } catch { return false; }
  });
  const [hudVisible, setHudVisible] = useState(true);
  const [fabOpen, setFabOpen] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (isMobile && immersive) document.body.classList.add('map-immersive');
    else document.body.classList.remove('map-immersive');
  }, [isMobile, immersive]);

  useEffect(() => {
    try { localStorage.setItem('ui@mobileImmersive', JSON.stringify(immersive)); } catch {}
  }, [immersive]);

  const pokeHud = () => {
    if (!(isMobile && immersive)) return;
    setHudVisible(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setHudVisible(false), 1200);
  };

  const onCanvasPointer = () => {
    if (isMobile) {
      setImmersive(true);
      pokeHud();
    }
  };

  const onFitView = () => {
    const reactFlowCanvas = document.querySelector('.react-flow');
    if (reactFlowCanvas && navigator.vibrate) navigator.vibrate(10);
    // el propio componente hace fitView; acá solo vibración
  };

  return (
    <ReactFlowProvider>
      <div onPointerDown={onCanvasPointer} onTouchStart={onCanvasPointer} style={{ position: 'relative' }}>
        <CareerMap {...props} />
        {isMobile && (
          <div className={`map-hud ${hudVisible ? '' : 'is-faded'}`} style={{ pointerEvents: 'none' }}>
            <div style={{ pointerEvents: 'auto' }}>
              <MapFabMobile
                open={fabOpen}
                setOpen={setFabOpen}
                onFit={onFitView}
                onToggleCBC={() => { if (navigator.vibrate) navigator.vibrate(10); /* accion externa */ }}
                onOpenGoals={() => {/* abrir panel objetivos */}}
                onOpenSettings={() => {/* abrir ajustes */}}
                onOpenHelp={() => {/* abrir ayuda */}}
              />
            </div>
          </div>
        )}
      </div>
    </ReactFlowProvider>
  );
};

export default CareerMapWrapper;
